var map = {
	"./1.png": 1398,
	"./2.png": 1399,
	"./3.png": 1400,
	"./avatar.png": 1401,
	"./crown-1.png": 1202,
	"./crown-2.png": 1203,
	"./crown-3.png": 1204,
	"./header-bg.png": 1095,
	"./like.png": 1065,
	"./logo.png": 1096,
	"./no-ranking.png": 1205,
	"./prize-bg.png": 1402,
	"./prize-top-bg.png": 1403,
	"./ranking-bg-1.png": 1404,
	"./ranking-bg-2.png": 1405,
	"./ranking-bg-3.png": 1406,
	"./start.png": 1097,
	"./top-up-bottom.png": 1407,
	"./top-up-popup.png": 1408,
	"./top-up.png": 1409,
	"./unlike.png": 1206
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2199;